import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'antd/dist/antd.css'; /* 1. 引入antd的样式文件 */
import './assets/style/reset.css'
ReactDOM.render(
  <App />,
  document.getElementById('root')
);
